import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@ntuctech/devex-tangram/Box';

const FormNoteSC = styled(Box)`
  * {
    color: #696969;
  }
`;

function FormNote({ children }) {
  return <FormNoteSC>{children}</FormNoteSC>;
}

FormNote.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormNote;
